import { Component } from '@angular/core';
import { PolicyHeaderComponent } from '../policy-header/policy-header.component';

@Component({
  selector: 'app-cp-10-54-06-07',
  standalone: true,
  imports: [PolicyHeaderComponent],
  templateUrl: './cp-10-54-06-07.component.html',
  styleUrl: './cp-10-54-06-07.component.scss'
})
export class Cp10540607Component {

}
